import { useRef, useState, useEffect } from "react";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from '../../api/axios';
import { Link, useNavigate, NavLink } from "react-router-dom";
import loginImg from '../../assets/images/login-img.png'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BsEyeSlash, BsEye } from "react-icons/bs";
import projectWiseLogo from '../../assets/images/pw-logo-white.png';

const USER_REGEX = /^[0-9]{6,10}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const OTP_REGEX = /^[0-9]{6,6}$/;


const Register = () => {
    const navigate = useNavigate();
    const errRef = useRef();
    const [initialState, setInitialState] = useState({
        user: '',
        validName: false,
        pwd: '',
        validPwd: false,
        matchPwd: '',
        validMatch: false,
        idFlag: false,
        emailState: false,
        emailOtp: '',
        validOtp: false,
        userEmail: '',
        confirmpasswordStatus: 'password',
        passwordStatus: 'password'
    });
    const [errMsg, setErrMsg] = useState({
        er_username : '',
        er_password : '',
        er_otp:'' ,
        er_con_password:''});
    
    // ------------------------------------------------------------------- Check System Id ------------------------ 
    const checkSysId = (e) => {
        e.preventDefault();
        if (initialState.user === null || initialState.user === "") {

            // toast.error("System id is required!", {
            //     position: toast.POSITION.TOP_RIGHT,
            //     theme: "colored",
            //     autoClose: 2000
            // });
            setErrMsg({...errMsg, er_username:"System Id is required!"})
        }
        else {
            axios.post('/signup', {
                username: initialState.user,
            }).then((response) => {
                if (response.data.message === "true") {
                    setInitialState({ ...initialState, idFlag: true, userEmail: response.data.email });
                }
                else if (response.data === 'exist') {
                    // toast.error("System id already exist!", {
                    //     position: toast.POSITION.TOP_RIGHT,
                    //     theme: "colored",
                    //     autoClose: 2000
                    // });
                    setErrMsg({...errMsg, er_username:"System Id already exist!"})
                }

                else {
                    // toast.error("System id does not exist!", {
                    //     position: toast.POSITION.TOP_RIGHT,
                    //     theme: "colored",
                    //     autoClose: 2000
                    // });
                    setErrMsg({...errMsg, er_username:"System Id does not exist!"})
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    }
    // ------------------------------------------------------------------- VERIFY OTP -----------------------------
    const verifyOtp = (e) => {
        e.preventDefault();
        try {
            if (initialState.emailOtp === null || initialState.emailOtp === "") {
                // toast.error("Otp is required!", {
                //     position: toast.POSITION.TOP_RIGHT,
                //     theme: "colored",
                //     autoClose: 2000
                // });
                setErrMsg({...errMsg, er_otp:"Please provide OTP!"})
            }
            else {
                axios.post('/otp', {
                    otp: initialState.emailOtp,
                    username: initialState.user,
                    email: initialState.userEmail
                }).then((response) => {
                    if (response.data) {
                        toast.success("Account is registered successfully. Please login to continue!", {
                            position: toast.POSITION.TOP_RIGHT,
                            theme: "colored",
                            autoClose: 2000
                        });

                        localStorage.setItem("firstTimeLogin", '****');
                        setTimeout(() => {
                            navigate("/", { replace: true });
                        }, 2000);

                    }

                    else {
                        // toast.error("Incorrect OTP Entered!", {
                        //     position: toast.POSITION.TOP_RIGHT,
                        //     theme: "colored",
                        //     autoClose: 2000
                        // });
                        setErrMsg({...errMsg, er_otp:"Incorrect OTP Entered!"})
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
        } catch (err) {
            console.log(err);
            if (!err?.response) {
                toast.error("No Server Response!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            } else if (err.response?.status === 409) {
                toast.error("Username already exist!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            } else {
                toast.error("Registration Failed!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            errRef.current.focus();
        }
    }
    // ------------------------------------------------------------------- Register Handle ------------------------ 
    const handleSubmit = (e) => {
        e.preventDefault();
        const v2 = PWD_REGEX.test(initialState.pwd);
        try {
            if (initialState.pwd === null || initialState.pwd === "") {
                // toast.error("Password is required!", {
                //     position: toast.POSITION.TOP_RIGHT,
                //     theme: "colored",
                //     autoClose: 2000
                // });
                setErrMsg({...errMsg, er_password:"Password is required!"})
            }
            else {

                if (!v2) {
                    toast.error("Password must be of 8 to 24 characters - 1 uppercase, 1 lowercase, 1 number and a special character!", {
                        position: toast.POSITION.TOP_RIGHT,
                        theme: "colored",
                        autoClose: 2000
                    });
                    return;
                }
                else {
                    if (initialState.matchPwd === null || initialState.matchPwd === "") {
                        // toast.error("Confirm password is required!", {
                        //     position: toast.POSITION.TOP_RIGHT,
                        //     theme: "colored",
                        //     autoClose: 2000
                        // });
                        setErrMsg({...errMsg, er_con_password:"Confirm password is required!"})
                    }
                    else {

                        if (!initialState.validMatch) {
                            // toast.error("Password does not matched!", {
                            //     position: toast.POSITION.TOP_RIGHT,
                            //     theme: "colored",
                            //     autoClose: 2000
                            // });
                            setErrMsg({...errMsg, er_con_password:"Password does not matched!"})
                        }
                        else {
                            axios.post('/password', {
                                username: initialState.user,
                                password: initialState.pwd,
                                email: initialState.userEmail,
                                randomotp: Math.floor(100000 + Math.random() * 900000),
                            }).then((response) => {
                                if (response.data) {
                                    toast.success("OTP has been sent successfully to your registered email id: " + initialState.userEmail, {
                                        position: toast.POSITION.TOP_RIGHT,
                                        theme: "colored",
                                        autoClose: 2000
                                    });
                                    setInitialState({ ...initialState, pwd: null, matchPwd: null, emailState: response.data });
                                }
                            }).catch(function (error) {
                                console.log(error);
                            });

                        }
                    }
                }
            }
        } catch (err) {
            if (!err?.response) {
                toast.error("No Server Response!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            } else if (err.response?.status === 409) {
                toast.error("Username already exist!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            } else {
                toast.error("Registration Failed!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            errRef.current.focus();
        }
    }
    // ------------------------------------------------------------------- Use Effect ----------------------------
    useEffect(() => {
        setInitialState({ ...initialState, validName: USER_REGEX.test(initialState.user), validPwd: PWD_REGEX.test(initialState.pwd), validMatch: initialState.pwd === initialState.matchPwd, validOtp: OTP_REGEX.test(initialState.emailOtp) });
    }, [initialState.user, initialState.pwd, initialState.emailOtp, initialState.matchPwd])
    // -------------------------------------------------------------------- HTML Start ---------------------------
    return (
            <div className="Almuni">
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="login-img">
                                <div className="loginvedio">
                                    {/* <video width="100%" height="100%" loop="" autoPlay="true" preload="auto" muted="" playsInline="">
                                        <source src={loginVideo} type="video/mp4" />
                                    </video> */}
                                    <img src={loginImg} alt="Forgot Password Images" />
                                </div>
                                <div className="mask" >
                                    <div className="mask-in">
                                        {/* <p>ProjectWise</p> */}
                                        <img src={projectWiseLogo} alt="ProjectWise Management Software" />
                                        <h1>Project Management Software</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-6">
                            <div className="login-page ">
                                <div className="login-field">
                                    {initialState.idFlag ? (
                                        initialState.emailState ? (
                                            <section>
                                                <h1>Sign up</h1>
                                                {/* <p>Please register your account here</p> */}
                                                <form onSubmit={verifyOtp} className="loginForm">
                                                    <div className="userField">
                                                        <label htmlFor="user_id">System ID</label>
                                                        <div className="input-icon">
                                                            <span className="icon"><i className="bi bi-x-circle"></i></span>
                                                            <input className="myInput" type="number" id="user_id" value={initialState.user} disabled />
                                                        </div>
                                                    </div>
                                                    <div className="userField">
                                                        <label htmlFor="otp">
                                                            OTP:
                                                        </label>
                                                        <div className="input-icon">
                                                            <input className="myInput"
                                                                type="number"
                                                                id="otp"
                                                                name="otp"
                                                                onChange={(e) =>{const inputValue = e.target.value.replace(/\D/g, "").slice(0, 6);setInitialState({ ...initialState, emailOtp: inputValue });setErrMsg({...errMsg,er_otp : ''})} }
                                                                value={initialState.emailOtp}
                                                                aria-invalid={initialState.validOtp ? "false" : "true"}
                                                                aria-describedby="pwdnote"
                                                                placeholder="Please enter OTP"
                                                                maxLength="6"
                                                                minLength="6"
                                                            />
                                                            {errMsg?.er_otp && <div className="errMsg">{errMsg?.er_otp}</div>}
                                                        </div>
                                                    </div>                                           
                                                    <button className="login-btn1">Submit</button>
                                                </form>
                                            </section>
                                        ) : (
                                            <section>
                                                <h1>Sign up</h1>
                                                {/* <p>Please fill your details to access your account.</p> */}
                                                <form onSubmit={handleSubmit} className="loginForm">
                                                    <div className="userField">
                                                        <label htmlFor="user_id">System ID</label>
                                                        <div className="input-icon">
                                                            <span className="icon"><i className="bi bi-x-circle"></i></span>
                                                            <input className="myInput" type="number" id="user_id" value={initialState.user} disabled />
                                                        </div>
                                                    </div>
                                                    <div className="userField">
                                                        <label htmlFor="password">
                                                            Password:
                                                            <FontAwesomeIcon icon={faCheck} className={initialState.validPwd ? "valid" : "hide"} />
                                                            <FontAwesomeIcon icon={faTimes} className={initialState.validPwd || !initialState.pwd ? "hide" : "invalid"} />
                                                        </label>
                                                        <div className="input-icon">
                                                        {initialState.passwordStatus === "password" ? < NavLink className="icon" onClick={() => setInitialState({ ...initialState, passwordStatus: "text" })} ><BsEyeSlash /></NavLink> :
                                                            <NavLink className="icon" onClick={() => setInitialState({ ...initialState, passwordStatus: "password" })} ><BsEye /></NavLink>}

                                                        <input className="myInput"
                                                            type={initialState.passwordStatus}
                                                            id="password"
                                                            name="password"
                                                            onChange={(e) => (setInitialState({ ...initialState, pwd: e.target.value }),setErrMsg({...errMsg,er_password : ''}))}
                                                            value={initialState.pwd}
                                                            aria-invalid={initialState.validPwd ? "false" : "true"}
                                                            aria-describedby="pwdnote"
                                                            placeholder="Please Enter Password"
                                                        />
                                                          {errMsg?.er_password && <div className="errMsg">{errMsg?.er_password}</div>}
                                                        </div>
                                                    </div>
                                                    <div className="userField">
                                                        <label htmlFor="confirm_pwd">
                                                            Confirm Password:
                                                            <FontAwesomeIcon icon={faCheck} className={initialState.validMatch && initialState.matchPwd ? "valid" : "hide"} />
                                                            <FontAwesomeIcon icon={faTimes} className={initialState.validMatch || !initialState.matchPwd ? "hide" : "invalid"} />
                                                        </label>
                                                        <div className="input-icon">
                                                            {initialState.confirmpasswordStatus === "password" ? < NavLink className="icon" onClick={() => setInitialState({ ...initialState, confirmpasswordStatus: "text" })} ><BsEyeSlash /></NavLink> :
                                                                <NavLink className="icon" onClick={() => setInitialState({ ...initialState, confirmpasswordStatus: "password" })} ><BsEye /></NavLink>}

                                                            <input className="myInput"
                                                                type={initialState.confirmpasswordStatus}
                                                                id="confirm_pwd"
                                                                onChange={(e) => (setInitialState({ ...initialState, matchPwd: e.target.value }),setErrMsg({...errMsg,er_con_password : ''}))}
                                                                value={initialState.matchPwd}
                                                                aria-invalid={initialState.validMatch ? "false" : "true"}
                                                                aria-describedby="confirmnote"
                                                                placeholder="Confirm Password"
                                                            />
                                                            {errMsg?.er_con_password && <div className="errMsg">{errMsg?.er_con_password}</div>}
                                                        </div>
                                                    </div>
                                                    <button className="login-btn1">Proceed</button>
                                                </form>
                                            </section>
                                        )
                                    ) : (
                                        <section>
                                            <h1>Sign up</h1>
                                            {/* <p>Please fill your details to access your account.</p> */}
                                            <p>Already registered ? <Link to="/">Sign In</Link></p>
                                            <form onSubmit={checkSysId} className="loginForm">
                                                <div className="userField">
                                                    <label htmlFor="user_id">
                                                        System ID:
                                                        <FontAwesomeIcon icon={faCheck} className={initialState.validName ? "valid" : "hide"} />
                                                        <FontAwesomeIcon icon={faTimes} className={initialState.validName || !initialState.user ? "hide" : "invalid"} />
                                                    </label>
                                                    <div className="input-icon">
                                                        <input className="myInput"
                                                            type="number"
                                                            id="user_id"
                                                            name="user_id"
                                                            autoComplete="off"
                                                            onChange={(e) => (setInitialState({ ...initialState, user: e.target.value }),setErrMsg({...errMsg,er_username : ''}))}
                                                            value={initialState.user}
                                                            aria-invalid={initialState.validName ? "false" : "true"}
                                                            aria-describedby="uidnote"
                                                            placeholder="Please enter System ID"
                                                        />
                                                        {errMsg?.er_username && <div className="errMsg">{errMsg?.er_username}</div>}
                                                    </div>
                                                </div>
                                                <button className="login-btn1">Proceed</button>
                                            </form>
                                        </section>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}
export default Register